/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  PutApiV2OrganizationsTeamsByOrganizationIdAndTeamIdParams,
  DeleteApiV2OrganizationsTeamsByOrganizationIdAndTeamIdParams,
  GetApiV2OrganizationsByIdParams,
  PutApiV2OrganizationsByIdParams,
  DeleteApiV2OrganizationsByIdParams,
  PutApiV2OrganizationsByIdBody,
  PostApiV2OrganizationsBody,
  PutApiV2OrganizationsTeamsByOrganizationIdAndTeamIdResponse,
  DeleteApiV2OrganizationsTeamsByOrganizationIdAndTeamIdResponse,
  GetApiV2OrganizationsByIdResponse,
  PutApiV2OrganizationsByIdResponse,
  GetApiV2OrganizationsResponse,
  PostApiV2OrganizationsResponse,
  GetApiV2OrganizationsTeamsResponse,
  GetApiV2OrganizationsMyResponse,
} from '../types';

export class Organizations extends Controller {
  async putApiV2OrganizationsTeamsByOrganizationIdAndTeamId<
    T extends PutApiV2OrganizationsTeamsByOrganizationIdAndTeamIdResponse,
    D,
    C extends null
  >(
    body: C,
    {
      organizationId,
      teamId,
    }: PutApiV2OrganizationsTeamsByOrganizationIdAndTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${organizationId}/teams/${teamId}`,
      body,
      axiosConfig
    );
  }

  async deleteApiV2OrganizationsTeamsByOrganizationIdAndTeamId<
    T extends DeleteApiV2OrganizationsTeamsByOrganizationIdAndTeamIdResponse,
    D,
    C extends null
  >(
    {
      organizationId,
      teamId,
    }: DeleteApiV2OrganizationsTeamsByOrganizationIdAndTeamIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${organizationId}/teams/${teamId}`,
      { ...axiosConfig, data: body }
    );
  }

  async getApiV2OrganizationsById<
    T extends GetApiV2OrganizationsByIdResponse,
    D,
    C
  >(
    { id }: GetApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      axiosConfig
    );
  }

  async putApiV2OrganizationsById<
    T extends PutApiV2OrganizationsByIdResponse,
    D,
    C extends PutApiV2OrganizationsByIdBody
  >(
    body: C,
    { id }: PutApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.put<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      body,
      axiosConfig
    );
  }

  async deleteApiV2OrganizationsById<T, D, C extends null>(
    { id }: DeleteApiV2OrganizationsByIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined,
    body?: C
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.delete<T, AxiosResponse<T, D>, C>(
      `/api/v2/organizations/${id}`,
      { ...axiosConfig, data: body }
    );
  }

  async getApiV2Organizations<T extends GetApiV2OrganizationsResponse, D, C>(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations',
      axiosConfig
    );
  }

  async postApiV2Organizations<
    T extends PostApiV2OrganizationsResponse,
    D,
    C extends PostApiV2OrganizationsBody
  >(
    body: C,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations',
      body,
      axiosConfig
    );
  }

  async getApiV2OrganizationsTeams<
    T extends GetApiV2OrganizationsTeamsResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations/teams',
      axiosConfig
    );
  }

  async getApiV2OrganizationsMy<
    T extends GetApiV2OrganizationsMyResponse,
    D,
    C
  >(
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      '/api/v2/organizations/my',
      axiosConfig
    );
  }
}
